export default __webpack_public_path__ + "static/media/xiaomi.bfb442e0.svg";